import { create } from "zustand";
import type { ApiUser } from "@content-os/types";
import { apiFetch } from "@/lib/api-client";

interface AuthState {
  user: ApiUser | null;
  isLoading: boolean;
  fetchUser: () => Promise<void>;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: true,

  fetchUser: async () => {
    try {
      const user = await apiFetch<ApiUser>("/auth/me");
      set({ user, isLoading: false });
    } catch {
      set({ user: null, isLoading: false });
    }
  },

  logout: async () => {
    try {
      await apiFetch("/auth/logout", { method: "POST" });
    } catch {
      // Clear local state regardless
    }
    set({ user: null });
  },
}));

// Derived selector
export const selectIsAuthenticated = (state: AuthState) => state.user !== null;
